'use strict';

const CompassionRole = {
    NURSE_CARE_MANAGER: 'nurse_care_manager',
    SOCIAL_WORKER: 'social_worker',
    CHAPLAIN: 'chaplain',
    NUTRITIONIST: 'nutritionist',
    ENROLLMENT_REVIEW: 'enrollment_review',
    PHYSICAL_THERAPIST: 'physical_therapist',
    CARE_COORDINATOR: 'care_coordinator',
    NURSE_PRACTITIONER: 'nurse_practitioner',
    MEDICAL_DIRECTOR: 'medical_director',
    EXECUTIVE_DIRECTOR: 'executive_director',
    TRIAGE_ENROLLMENT_NURSE: 'triage_enrollment_nurse',
    ADMINISTRATOR: 'administrator',
    ADMINISTRATIVE_SUPPORT: 'administrative_support',
    BROKER_ACCESS: 'broker_access',
    CSR_AGENT: 'csr_agent'
};

const NON_CLINICAL_ROLES = [
    CompassionRole.BROKER_ACCESS,
    CompassionRole.CSR_AGENT,
    CompassionRole.ADMINISTRATIVE_SUPPORT,
    CompassionRole.ADMINISTRATOR,
    CompassionRole.CARE_COORDINATOR,
    CompassionRole.EXECUTIVE_DIRECTOR,
    CompassionRole.MEDICAL_DIRECTOR,
    CompassionRole.SOCIAL_WORKER,
    CompassionRole.TRIAGE_ENROLLMENT_NURSE
];

const CLINICAL_ROLES = Object.values(CompassionRole).filter(
    (r) => !NON_CLINICAL_ROLES.includes(r)
);

module.exports = {
    CompassionRole,
    CLINICAL_ROLES,
    NON_CLINICAL_ROLES
};
